import {RcFile} from 'antd/lib/upload';

import {deserializeV2, fetchAndDeserialize, serialize} from '../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent, fetchX} from '../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../api/api-const';
import {buildPublicationListQuery} from '../publication/publication-filter-helper';
import {PublicationListFilterType} from '../publication/publication-filter-type';

import {
    eventDetailSchema,
    EventDetailType,
    EventRequestType,
    eventSelectedCompaniesSchema,
    EventSelectedCompaniesType,
    eventsListResponseSchema,
    EventsListResponseType,
    uploadEventImageResponseSchema,
    UploadEventImageResponseType,
} from './events-type';

export async function fetchEvents(
    page: number | null,
    filter?: PublicationListFilterType
): Promise<EventsListResponseType> {
    return fetchAndDeserialize<EventsListResponseType>(
        `/cp/events/?${buildPublicationListQuery(page, filter)}`,
        eventsListResponseSchema
    );
}

export async function fetchEventSelectedCompanies(
    eventId: number,
    page: number | null
): Promise<EventSelectedCompaniesType> {
    return fetchAndDeserialize<EventSelectedCompaniesType>(
        `/cp/events/${eventId}/companies_details/?page=${page}`,
        eventSelectedCompaniesSchema
    );
}

export async function fetchEventById(eventId: number): Promise<EventDetailType> {
    return fetchAndDeserialize<EventDetailType>(`/cp/events/${eventId}/`, eventDetailSchema);
}

export function createEvent(data: EventRequestType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/events/create/`, {
        method: FetchMethodEnum.post,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function updateEvent(eventId: number, data: EventRequestType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/events/${eventId}/`, {
        method: FetchMethodEnum.put,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function deleteEvent(eventId: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/events/${eventId}/delete/`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export async function uploadEventImage(file: RcFile): Promise<UploadEventImageResponseType> {
    const url = `${rootApiUrl}/cp/events/images/`;

    const formData = new FormData();

    formData.append('image', file);

    const response = await fetchX(url, {
        method: FetchMethodEnum.post,
        headers: {...getCsrfHeaders()},
        body: formData,
    });

    return deserializeV2<UploadEventImageResponseType>(url, uploadEventImageResponseSchema, response);
}

export function deleteEventImage(imageId: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/events/images/${imageId}/`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}
